import { NextRouter } from 'next/router';
import { NotificationProps } from '~/interfaces/notification';

type getNotificationTypeProps = {
   router: NextRouter;
   lang: string;
   notification: NotificationProps;
   translate: (value: any) => any;
};

export const getNotificationType = ({
   router,
   lang,
   notification,
   translate,
}: getNotificationTypeProps) => {
   switch (notification.type) {
      case 'Halayalla\\Providers\\Notifications\\Product\\ProductSent':
         return {
            text: translate({ id: 'notification:product submitted' }),
            route: () => router.push(`/${lang}/products/${notification?.data?.product?._id}`),
            actionText: translate({ id: 'notification:go to product' }),
         };
      case 'Halayalla\\Providers\\Notifications\\Payout\\PayoutSent':
         return {
            text: translate({ id: 'notification:payout sent for review' }),
            route: () => router.push(`/${lang}/profile/business/payout`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Payout\\PayoutApproved':
         return {
            text: translate({ id: 'notification:payout approved' }),
            route: () =>
               router.push(`/${lang}/payout-request/${notification.data.payout_request._id}`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Payout\\PayoutRejected':
         return {
            text: translate({ id: 'notification:payout rejected' }),
            route: () =>
               router.push(`/${lang}/payout-request/${notification.data.payout_request._id}`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Profile\\ProfileApproved':
         return {
            text: translate({ id: 'notification:profile approved' }),
            route: () => window.open(`${process.env.NEXT_PUBLIC_SSID_URL}`, '_blank', 'noopener'),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Profile\\ProfileRejected':
         return {
            text: translate({ id: 'notification:action required' }),
            route: () => router.push(`/${lang}/profile/business/files`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Profile\\ProfileSent':
         return {
            text: translate({ id: 'notification:profile sent for review' }),
            route: () => window.open(`${process.env.NEXT_PUBLIC_SSID_URL}`, '_blank', 'noopener'),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Profile\\BankDetailsUpdates':
         return {
            text: translate({ id: 'notification:bank details updated' }),
            route: () => router.push(`/${lang}/profile/business/billing-info`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Profile\\BankDetailsAdded':
         return {
            text: translate({ id: 'notification:bank details updated' }),
            route: () => router.push(`/${lang}/profile/business/billing-info`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\User\\EmailChanged':
         return {
            text: translate({ id: 'notification:user email changed' }),
            route: () => window.open(`${process.env.NEXT_PUBLIC_SSID_URL}`, '_blank', 'noopener'),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\User\\MobileChanged':
         return {
            text: translate({ id: 'notification:user mobile changed' }),
            route: () => window.open(`${process.env.NEXT_PUBLIC_SSID_URL}`, '_blank', 'noopener'),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\User\\PasswordChanged':
         return {
            text: translate({ id: 'notification:user password changed' }),
            route: () => window.open(`${process.env.NEXT_PUBLIC_SSID_URL}`, '_blank', 'noopener'),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Product\\ProductApproved':
         return {
            text: translate({ id: 'notification:product approved' }),
            route: () => router.push(`/${lang}/products/${notification?.data?.product?._id}`),
            actionText: translate({ id: 'notification:go to product' }),
         };
      case 'Halayalla\\Providers\\Notifications\\Product\\ProductRejected':
         return {
            text: translate({ id: 'notification:product rejected' }),
            route: () => router.push(`/${lang}/products/${notification?.data?.product?._id}`),
            actionText: translate({ id: 'notification:go to product' }),
         };
      case 'Halayalla\\Providers\\Notifications\\Profile\\BankDetailsForAutoPayout':
         return {
            text:
               notification.data?.request_bank_info?.message?.[lang] || 'Please add your bank info',
            route: () => router.push(`/${lang}/profile/business/billing-info`),
            actionText: '',
         };
      case 'Halayalla\\Providers\\Notifications\\Product\\ProductUnpublished':
         return {
            text: translate({ id: 'notification:product unpublished' }),
            route: () => router.push(`/${lang}/products/${notification?.data?.product?._id}`),
            actionText: translate({ id: 'notification:go to product' }),
         };
   }
};
